import { formatDobDisplay } from './dateUtils';

/**
 * Identity cues that tell same-named Person charts apart before one is opened.
 * Mirrors the case-creation duplicate review (IdentityReviewPanel), which
 * distinguishes same-name candidates by DOB and phone.
 */
export interface PersonIdentityCues {
  birthdate?: string | null;
  phone?: string | null;
}

export function formatPhoneSuffix(phone: string | null | undefined): string | null {
  const digits = (phone || '').replace(/\D/g, '');
  return digits.length >= 4 ? `…${digits.slice(-4)}` : null;
}

export function formatDobCue(birthdate: string | null | undefined): string {
  const dob = formatDobDisplay(birthdate);
  return dob ? `DOB ${dob}` : 'DOB not on file';
}

/** "DOB 03/14/1995 · ph …1234" — DOB always shown; a missing DOB is stated, not hidden. */
export function formatPersonDisambiguator({ birthdate, phone }: PersonIdentityCues): string {
  const phoneSuffix = formatPhoneSuffix(phone);
  return [formatDobCue(birthdate), phoneSuffix ? `ph ${phoneSuffix}` : null]
    .filter(Boolean)
    .join(' · ');
}
